import PresentationIcon from './PresentationIcon'

export default PresentationIcon
